import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-pricing-modif-editor',
  templateUrl: './pricing-modif-editor.component.html',
  styleUrls: ['./pricing-modif-editor.component.scss']
})
export class PricingModifEditorComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
